import { registryApi } from '../clients/AxiosClients'

const getAllInventarioFlorestal = async () => {
	console.log(registryApi.get('v2/EstratoInventarioFlorestal/lista-dados-para-grid'))

	return registryApi.get('v2/EstratoInventarioFlorestal/lista-dados-para-grid')
}

export { getAllInventarioFlorestal }
